/* eslint-disable no-inline-styles/no-inline-styles */
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const Missing = () => {
  return (
    <Box component="article" sx={{ padding: '100px' }}>
      <Typography variant="h5">Oops!</Typography>
      <Typography variant="body1">Page Not Found</Typography>
      <Box className="flexGrow">
        <Link to="/">Visit Our Homepage</Link>
      </Box>
    </Box>
  );
};

export default Missing;
